<template>
    <div>
        <div class="card">
            <h5 class="card-header bg-primary text-light abc">
                <span class="card-header-text">Key Points</span>
            </h5>
            <div class="card-body bg-light pb-0">
                <ul v-if="typeof this.keypoints === Object">
                    <li v-for="(keypoint, index) in keypoints" :key="index">
                        <p class="accordion-text" v-html="keypoint" />
                    </li>
                </ul>
                <ul v-if="typeof this.keypoints !== Object">
                    <li v-for="(keypoint, index) in keypoints" :key="index">
                        <p class="accordion-text" v-html="keypoint" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        keypoints: Object
    }
}
</script>

<style>
@media print {
    .card-header-text {
        color: black !important;
    }
}
</style>